// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"47844d3d5417ac8d","5038":"435c71bfb57428e3","5405":"dd19a6863df21303"}[chunkId] + ".css";
};